<div class="kg-header">
  <h5 class="kg-title">Knowledge Graph</h5>
  <button
    type="button"
    class="accello-icon-btn"
    aria-label="Close"
    (mousedown)="isCloseActive = true"
    (mouseup)="isCloseActive = false"
    (mouseleave)="isCloseActive = false"
    (click)="activeModal.dismiss('Cross click')"
  >
    <img
      alt="close"
      [src]="
        isCloseActive
          ? 'assets/images/virtusa-icons/close-dark.svg'
          : 'assets/images/virtusa-icons/close.svg'
      "
    />
  </button>
</div>

<!-- ─── Body ────────────────────────────────────────────────────────────────── -->
<div class="kg-body">

  <!-- ─── Left: filter panel ──────────────────────────────────────────────── -->
  <div class="kg-filter-panel">

    <!-- Top controls (scroll as needed) -->
    <div class="kg-filter-scroll">

      <!-- Graph Type ───────────────────────────────────────── -->
      <div class="kg-section">
        <p class="kg-label">Graph Type</p>
        <div class="kg-option-grid">
          <!-- 1. Unified Graph — first, default, shows ALL nodes and edges -->
          <div
            class="kg-option-card"
            [class.kg-option-card--active]="activeType === 'appContext'"
            (click)="onTypeSelect('appContext')"
            (keydown.enter)="onTypeSelect('appContext')"
            tabindex="0"
          >
            Unified Graph
          </div>
          <!-- 2. Story-Driven Graph — filtered by selected stories -->
          <div
            class="kg-option-card"
            [class.kg-option-card--active]="activeType === 'storyDriven'"
            (click)="onTypeSelect('storyDriven')"
            (keydown.enter)="onTypeSelect('storyDriven')"
            tabindex="0"
          >
            Story-Driven Graph
          </div>
        </div>
      </div>

      <!-- User Story ID — multi-select with checkboxes (story-driven only) ── -->
      <div class="kg-section" *ngIf="activeType === 'storyDriven'">
        <p class="kg-label">User Story ID</p>

        <div class="kg-multiselect" (click)="$event.stopPropagation()">
          <!-- Trigger -->
          <button
            type="button"
            class="kg-multiselect-trigger"
            [class.open]="isStoryDropdownOpen"
            (click)="toggleStoryDropdown($event)"
          >
            <span class="kg-multiselect-value" [class.placeholder]="selectedStoryIds.length === 0">
              {{ storyDropdownLabel }}
            </span>
            <i class="bi"
              [class.bi-chevron-up]="isStoryDropdownOpen"
              [class.bi-chevron-down]="!isStoryDropdownOpen">
            </i>
          </button>

          <!-- Dropdown panel -->
          <div class="kg-multiselect-panel" *ngIf="isStoryDropdownOpen">
            <!-- "All" row with indeterminate support -->
            <label class="kg-multiselect-option kg-multiselect-all" (click)="toggleAllStories($event)">
              <span class="kg-checkbox"
                [class.checked]="isAllStoriesSelected"
                [class.indeterminate]="isSomeStoriesSelected">
                <i *ngIf="isAllStoriesSelected" class="bi bi-check-lg"></i>
                <i *ngIf="isSomeStoriesSelected && !isAllStoriesSelected" class="bi bi-dash-lg"></i>
              </span>
              <span class="kg-option-label">All</span>
            </label>

            <div class="kg-multiselect-divider"></div>

            <!-- Individual story rows -->
            <label
              *ngFor="let id of allStoryIds"
              class="kg-multiselect-option"
              (click)="toggleStoryId($event, id)"
            >
              <span class="kg-checkbox" [class.checked]="isStorySelected(id)">
                <i *ngIf="isStorySelected(id)" class="bi bi-check-lg"></i>
              </span>
              <span class="kg-option-label">{{ id }}</span>
            </label>
          </div>
        </div>
      </div>

      <!-- Weight ───────────────────────────────────────────────── -->
      <div class="kg-section" *ngIf="activeType === 'storyDriven' && filterOptions.weights?.length">
        <p class="kg-label">Weight</p>
        <div class="kg-weight-grid">
          <div
            class="kg-option-card kg-option-card--chip"
            [class.kg-option-card--active]="filterData.weight === ''"
            (click)="onWeightChipSelect('')"
            (keydown.enter)="onWeightChipSelect('')"
            tabindex="0"
          >
            All
          </div>
          <div
            *ngFor="let opt of filterOptions.weights"
            class="kg-option-card kg-option-card--chip"
            [class.kg-option-card--active]="filterData.weight === opt.value"
            (click)="onWeightChipSelect(opt.value)"
            (keydown.enter)="onWeightChipSelect(opt.value)"
            tabindex="0"
          >
            Low ({{ opt.low }}) – High ({{ opt.high }})
          </div>
        </div>
      </div>

    </div><!-- /kg-filter-scroll -->

    <!-- Download button — pinned to bottom of panel ──────────────────────── -->
    <div class="kg-download-wrap">
      <button
        class="kg-download-btn"
        [disabled]="isDownloading"
        (click)="downloadGraphAsHTML()"
      >
        <i class="bi bi-download"></i>
        Download graph
        @if (isDownloading) {
          <span class="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>
        }
      </button>
    </div>

  </div><!-- /kg-filter-panel -->

  <!-- ─── Right: graph canvas ─────────────────────────────────────────────── -->
  <div class="kg-graph-area">
    <!-- Loading spinner -->
    <div *ngIf="isLoading" class="kg-graph-overlay">
      <app-loading></app-loading>
    </div>

    <!-- Async progress bar -->
    <div *ngIf="!isLoading && displayProgress" class="kg-graph-overlay">
      <app-progress-bar
        [text]="progressText"
        [progress]="percentage"
        [isError]="isProgressError"
        class="w-75"
      ></app-progress-bar>
    </div>

    <!-- vis-network container — always in DOM so @ViewChild resolves -->
    <div
      #networkContainer
      class="kg-network"
      [hidden]="isLoading || displayProgress"
    ></div>
  </div>
</div><!-- /kg-body -->
